<template>
  <div>
    <VideoIntroDialog
      v-if="profile.youtube_link"
      v-model="dialog"
      :link="profile.youtube_link"
      :title="videoTitle"
    />
    <div 
      :class="'avatar ' + (profile.youtube_link ? 'pointer' : '')"
      @click="openVideo"
    >
      <div v-if="profile.youtube_link" class="play-icon-wrapper">
        <div class="play-icon">
          <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzgiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCAzOCA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggaWQ9IlBvbHlnb24gMSIgZD0iTTM2IDE4LjUzNTlDMzguNjY2NyAyMC4wNzU1IDM4LjY2NjcgMjMuOTI0NSAzNiAyNS40NjQxTDYgNDIuNzg0NkMzLjMzMzMzIDQ0LjMyNDIgMS42OTkwOGUtMDYgNDIuMzk5NyAxLjgzMzY3ZS0wNiAzOS4zMjA1TDMuMzQ3ODhlLTA2IDQuNjc5NDlDMy40ODI0OGUtMDYgMS42MDAyOSAzLjMzMzM0IC0wLjMyNDIxMSA2IDEuMjE1MzlMMzYgMTguNTM1OVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=" alt="" title="">
        </div>
      </div>

      <!-- any photo is cut into a circle (cover), a non-square one is no longer squeezed or turned into an oval -->
      <v-img
        class="border-rounded align-self-center"
        :aspect-ratio="1"
        :width="size"
        :max-width="size"
        position="center 25%"
        :src="profile.photo"
      ></v-img>
    </div>
  </div>
</template>

<script>
import VideoIntroDialog from "@/components/UI/VideoIntroDialog";

export default {
  name: 'PsychologistAvatar',
  components: { VideoIntroDialog },
  props: {
    profile: {
      type: Object,
      required: true,
      default: () => {},
    },
    size: {
      type: Number,
      required: false,
      default: 220,
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    videoTitle() {
      const name = [this.profile.name, this.profile.surname].filter(Boolean).join(" ");
      const label = this.$vuetify.lang.t("$vuetify.view.common.videoIntroduction");
      return name ? `${label} · ${name}` : label;
    },
  },
  methods: {
    openVideo(event) {
      if (this.profile.youtube_link) {
        // the photo sits inside the clickable catalog card: the video opens instead of the profile
        if (event) event.preventDefault();
        this.dialog = true;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.video {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%; /* 16:9 */
  overflow: hidden;
  min-height: 200px;
}

.video iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.avatar {
  position: relative;
}

.avatar.pointer {
  cursor: pointer;
}

.play-icon-wrapper {
  position: absolute;
  width: 30%;

  right: 10px;
  bottom: 10px;
}

.play-icon {
  position: relative;
  width: 100%;
  padding-top: 100%;

  border-radius: 50%;
  background: rgba(37, 169, 196, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;

  transition: all 0.3s;
}

.avatar:hover .play-icon {
  transform: scale(0.85);
}

.play-icon img {
  width: 50%;
  height: 50%;
  margin-left: 5px;
  position: absolute;
  top: 25%;
  bottom: 25%;
}

.border-rounded {
  border-radius: 50% !important;
}
</style>
